/** A depth axis that sits near zero hides a move of a few decimetres. Padding keeps it readable. */
const MIN_PADDING_METRES = 0.1;
const PADDING_RATIO = 0.1;

/**
 * Bounds for an inverted depth axis: the data, plus the larger of 0.1 m and 10% of the span.
 *
 * An empty list returns undefined so the caller can leave the axis to Chart.js. Equal values
 * still get the 0.1 m padding, so a pen that sat at 35.4 m is not drawn as a single tick.
 */
export function depthAxisRange(
    values: readonly number[]
): { min: number; max: number } | undefined {
    const finite = values.filter((value) => Number.isFinite(value));
    if (finite.length === 0) return undefined;

    const low = Math.min(...finite);
    const high = Math.max(...finite);
    const padding = Math.max(MIN_PADDING_METRES, (high - low) * PADDING_RATIO);
    // Millimetres. Stops 35.7 + 0.1 landing as 35.800000000000004 on the axis.
    const round = (value: number) => Math.round(value * 1000) / 1000;
    return { min: round(low - padding), max: round(high + padding) };
}
